import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { numberWithCommas, parseNumberWithCommas, logger } from '../../../../../helpers';
import { trackingEvent } from '../../../../../helpers/tracking';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderInput from '../../../../../common/components/render-input';

export const formName = Routes.STEPONE;

const tracking = {
    eventAction: 'Mortgage Calculator - Step 1',
    eventLabel: 'Your Monthly Debt'
};

const annualIncomeMin = 1;

const validate = values => v(values, {
    annualIncome: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        },
        numericality: {
            greaterThanOrEqualTo: annualIncomeMin,
            notGreaterThanOrEqualTo: `must be greater than $0`,
        }
    }
});

class StepOneForm extends Component {
    componentDidMount() {
        logger.logUserAction('form_step_loaded', 'MortgageCalculator-Step1', {
            step: 1,
            formName: formName,
            url: window.location.href
        });
    }

    componentDidUpdate(prevProps) {
        // Log validation errors
        if (this.props.invalid && this.props.submitFailed && this.props.syncErrors) {
            logger.warn('Form validation failed in Step 1', {
                step: 1,
                formName: formName,
                errors: this.props.syncErrors,
                values: this.props.values
            });
        }
    }

    render() {
        return (
            <form className={styles.form}>
                <Field
                    type='text'
                    name='annualIncome'
                    label='Household Gross Income'
                    prefix='$'
                    format={numberWithCommas}
                    parse={parseNumberWithCommas}
                    component={RenderInput}
                    onChange={(event, newValue, previousValue) => {
                        if (newValue !== previousValue) {
                            logger.logUserAction('field_changed', 'MortgageCalculator-Step1', {
                                step: 1,
                                field: 'annualIncome',
                                previousValue,
                                newValue
                            });
                        }
                    }}
                />
            </form>
        );
    }
}

StepOneForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    redirectPath: `/mortgage${Routes.STEPTWO}`,
    tracking: () => trackingEvent(tracking)
})(StepOneForm);

export default withRouter(StepOneForm);
